var _dec, _dec2, _dec3, _class, _class2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { CustomElement, Prop, Component } from '@sick-davinci/ce-decorators';
import { isColor, isPaletteIdentifier, toCssColors } from './ColorTools.js'; // import theme, so color-variables can be resolved

import '@sick-davinci/theme-base/theme/light_theme.js';
import '@sick-davinci/theme-base/theme/light_ddg_theme.js';
/**
 * Base class for colorful custom elements
 */

export let ColoredDataElement = (_dec = Component({
  tag: 'davinci-colored-data-element',
  abstract: true
}), _dec2 = Prop({
  converter: {
    fromAttribute: value => {
      if (isPaletteIdentifier(value)) {
        return value;
      } // must be an array at this point


      return JSON.parse(value);
    },
    toAttribute: value => {
      if (isPaletteIdentifier(value)) {
        return value;
      } // must be an array at this point


      return JSON.stringify(value);
    }
  }
}), _dec3 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class ColoredDataElement extends CustomElement {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_palette", 'primary');

    _defineProperty(this, "_userDefinedSeriesColors", null);
  }

  /**
   * The colors to be used for the data series.
   * The first element denotes the color for the first series,
   * the second element denotes the color for the second series and so on.
   * @default all colors of the current color-palette
   */
  _getSeriesColors() {
    if (this._userDefinedSeriesColors === null || this._userDefinedSeriesColors.length === 0) {
      // no user-defined color -> use all colors of the current palette
      return toCssColors(this._palette);
    }

    return this._userDefinedSeriesColors;
  }
  /**
   * Sets the colors to be used for the data series.
   * @param colors the colors of the data series; pass null or an empty array to use all colors of the current color-palette
   */


  _setSeriesColors(colors) {
    if (colors === null) {
      this._userDefinedSeriesColors = null;
    } else {
      const newColors = colors.filter(color => isColor(color));
      this._userDefinedSeriesColors = newColors.length ? newColors : null;
    }
  }
  /**
   * The color palette to be used to style this element.
   *
   * This can either be an identifier (string) of a predefined color palette or an array of CSS colors.
   *
   * Valid identifiers are 'namur', 'color-blind', 'primary', 'secondary' and 'state'.
   *
   * @default primary
   */


  get palette() {
    return this._palette;
  }

  set palette(newPalette) {
    this._palette = newPalette;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "palette", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "palette"), _class2.prototype)), _class2)) || _class);
